export enum SessionActions {
  SESSION_EXPIRED_CONSENT = "SESSION_EXPIRED_CONSENT",
  SESSION_HARD_CAP_EXPIRED = "SESSION_HARD_CAP_EXPIRED",
  CLEAR_SESSION_EXPIRY = "CLEAR_SESSION_EXPIRY",
}

export function showSessionExpiredConsent() {
  return { type: SessionActions.SESSION_EXPIRED_CONSENT };
}

export function showSessionHardCapExpired() {
  return { type: SessionActions.SESSION_HARD_CAP_EXPIRED };
}

export function clearSessionExpiry() {
  return { type: SessionActions.CLEAR_SESSION_EXPIRY };
}

// Consent gate: the request layers (RTK baseQuery / axios middleware) dispatch
// the consent screen and then await this promise. The consent modal resolves it
// with `true` (extend) or `false` (log out). Concurrent requests share one gate.
let consentResolver: ((consented: boolean) => void) | null = null;
let consentPromise: Promise<boolean> | null = null;

export function requestSessionExtension(): Promise<boolean> {
  if (!consentPromise) {
    consentPromise = new Promise<boolean>((resolve) => {
      consentResolver = resolve;
    });
  }
  return consentPromise;
}

export function resolveSessionExtension(consented: boolean) {
  consentResolver?.(consented);
  consentResolver = null;
  consentPromise = null;
}
